export interface Stadium {
  name: string;
  team: string;
  teamId: number;
  note?: string;
}

export interface StadiumCluster {
  id: string;
  emoji: string;
  name: string;
  tagline: string;
  stadiums: Stadium[];
}

export const STADIUM_CLUSTERS: StadiumCluster[] = [
  {
    id: 'northeast',
    emoji: '🗽',
    name: 'Northeast Corridor',
    tagline: 'Dense, highly connected',
    stadiums: [
      { name: 'Yankee Stadium', team: 'Yankees', teamId: 147 },
      { name: 'Citi Field', team: 'Mets', teamId: 121 },
      { name: 'Citizens Bank Park', team: 'Phillies', teamId: 143 },
      { name: 'Oriole Park at Camden Yards', team: 'Orioles', teamId: 110 },
      { name: 'Nationals Park', team: 'Nationals', teamId: 120 },
      { name: 'PNC Park', team: 'Pirates', teamId: 134, note: 'just under 4 hours from Baltimore/DC' },
      { name: 'Fenway Park', team: 'Red Sox', teamId: 111, note: '~3.5–4 hours from NYC' },
    ]
  },
  {
    id: 'greatlakes',
    emoji: '🧀',
    name: 'Great Lakes / Midwest',
    tagline: 'A compact, road-trip-friendly loop',
    stadiums: [
      { name: 'Wrigley Field', team: 'Cubs', teamId: 112 },
      { name: 'Guaranteed Rate Field', team: 'White Sox', teamId: 145 },
      { name: 'American Family Field', team: 'Brewers', teamId: 158 },
      { name: 'Comerica Park', team: 'Tigers', teamId: 116 },
      { name: 'Progressive Field', team: 'Guardians', teamId: 114 },
      { name: 'Great American Ball Park', team: 'Reds', teamId: 113 },
      { name: 'PNC Park', team: 'Pirates', teamId: 134, note: 'also overlaps with Northeast cluster' },
    ]
  },
  {
    id: 'socal',
    emoji: '🌵',
    name: 'Southern California',
    tagline: 'The only Western parks within 4 hours of each other',
    stadiums: [
      { name: 'Dodger Stadium', team: 'Dodgers', teamId: 119 },
      { name: 'Angel Stadium', team: 'Angels', teamId: 108 },
      { name: 'Petco Park', team: 'Padres', teamId: 135 },
    ]
  },
  {
    id: 'norcal',
    emoji: '🌉',
    name: 'Northern California',
    tagline: 'A small but valid pair',
    stadiums: [
      { name: 'Oracle Park', team: 'Giants', teamId: 137 },
      { name: 'Sutter Health Park', team: 'Athletics', teamId: 133, note: 'temporary home' },
    ]
  },
  {
    id: 'texas',
    emoji: '🌄',
    name: 'Texas Pair',
    tagline: 'Texas is huge, but these two are close enough',
    stadiums: [
      { name: 'Globe Life Field', team: 'Rangers', teamId: 140 },
      { name: 'Minute Maid Park', team: 'Astros', teamId: 117, note: 'also known as Daikin Park' },
    ]
  },
  {
    id: 'florida',
    emoji: '🐟',
    name: 'Florida Pair',
    tagline: 'Another simple two-park cluster',
    stadiums: [
      { name: 'Tropicana Field', team: 'Rays', teamId: 139, note: 'temporary home: Steinbrenner Field' },
      { name: 'loanDepot Park', team: 'Marlins', teamId: 146 },
    ]
  },
];

export const STANDALONE_STADIUMS: Stadium[] = [
  { name: 'Coors Field', team: 'Rockies', teamId: 115 },
  { name: 'Chase Field', team: 'Diamondbacks', teamId: 109 },
  { name: 'T-Mobile Park', team: 'Mariners', teamId: 136 },
  { name: 'Target Field', team: 'Twins', teamId: 142 },
  { name: 'Kauffman Stadium', team: 'Royals', teamId: 118 },
  { name: 'Busch Stadium', team: 'Cardinals', teamId: 138 },
  { name: 'Truist Park', team: 'Braves', teamId: 144 },
  { name: 'Rogers Centre', team: 'Blue Jays', teamId: 141 },
];
